import { actionKitImpFunction } from '../../../../components/ozmoit/common';
import { searchCourseGroupingsForCourseRequest } from '../api';
import { CourseGroupListQuery } from '../api';

// HU 15577 — Task B2: action para buscar agrupaciones de asignaturas desde el
// modal de asociación. Reutiliza el endpoint de listado de course-groups.

export const searchCourseGroupingsForCourseAction = actionKitImpFunction(
  async (params: Partial<CourseGroupListQuery>) => {
    const response = await searchCourseGroupingsForCourseRequest(params);
    if (response.error) {
      throw response.error;
    }
    return response.data;
  },
);
